<template>
  <div class="api-layer">
    <fieldset>
      <legend>System</legend>

      <div class="api-box"
           :class="{inline: !serverInfo.desc}"
      >
        <label class="api-title">server</label>
        <button @click="getServerInfo">OK</button>
        <div
            v-if="!!serverInfo.desc"
        >
          <pre>
            LastReq: {{serverInfo.desc.lastReqDate}}
            ServerId: {{serverInfo.desc.serverId}}
            CpuLoad: {{serverInfo.desc.cpuLoad}} %
            CpuProcs: {{serverInfo.desc.arch}}, {{serverInfo.desc.availableProcessors}} cores
            Memory: total[{{ serverInfo.desc.totalPhysicalMemorySize }}MB], use[{{ serverInfo.desc.usePhysicalMemorySize }}MB], free[{{ serverInfo.desc.freePhysicalMemorySize }}MB]
          </pre>
        </div>
      </div>

      <div class="api-box"
           :class="{inline: !systemInfo.desc}"
      >
        <label class="api-title">system</label>
        <button @click="getSystemInfo">OK</button>
        <div
            v-if="!!systemInfo.desc"
        >
          <pre>
            LastReq: {{systemInfo.desc.lastReqDate}}
            ServerId: {{systemInfo.desc.serverId}}
            Memory: total[{{ systemInfo.desc.memory.total }}MB], use[{{ systemInfo.desc.memory.use }}MB], free[{{ systemInfo.desc.memory.free }}MB], max[{{ systemInfo.desc.memory.max }}MB]
          </pre>
        </div>
      </div>

      <div></div>

      <div class="api-box"
           :class="{inline: !configInfo.data}"
      >
        <label class="api-title">config</label>
        <button @click="getConfigAll">OK</button>
        <div
            v-if="!!configInfo.data"
        >
          <pre>{{configInfo.data}}</pre>
        </div>
      </div>
    </fieldset>
  </div>
</template>

import {SysAdmin} from "@/core/sysadmin/sysadmin.api";

<script>
import {SysAdmin} from "@/core/sysadmin/sysadmin.api";
import SysAdminBase from "@/components/Sysadmin/SysAdminBase";

export default {
  name: "System",
  mixins: [SysAdminBase],
  data() {
    return {
      serverInfo: {
        desc: null
      },
      systemInfo: {
        desc: null
      },

      configInfo: {
        data: null
      }
    }
  },

  methods: {
    async getConfigAll() {
      if(!confirm('go?')) return;

      const data = await SysAdmin.get({url: '/config/all'})
      console.log(data);

      // date
      data.lastReqDate = new Date();

      this.configInfo.data = data;
    },
    ...(() => {
      const methods = {
        async getServerInfo() {
          const data = await SysAdmin.get({url: '/server/info'})
          console.log(data);

          // date
          data.lastReqDate = new Date();

          // cpu
          data.cpuLoad = (data.cpuLoad*100).toFixed(2);

          // memory
          (() => {
            for(let key in data){
              if(key.includes('MemorySize')){
                data[key] = parseInt(data[key] / 1024 / 1024);
              }
            }
            data.usePhysicalMemorySize = data.totalPhysicalMemorySize - data.freePhysicalMemorySize;
          })();

          this.serverInfo.desc = data;
        },
        async getSystemInfo() {
          const data = await SysAdmin.get({url: '/system/info'})
          console.log(data);

          // date
          data.lastReqDate = new Date();

          // memory
          for(let key in data.memory){
            data.memory[key] = parseInt(data.memory[key] / 1024 / 1024);
          }
          data.memory.use = data.memory.total - data.memory.free;

          this.systemInfo.desc = data;
        },
      }

      return SysAdmin.createDebounceMethods(methods);
    })()
  }
}
</script>

<style lang="scss">
</style>